import React from 'react';
import { Icon } from 'antd';

const optionsDefault = {
  okText: 'Готово',
  icon: <Icon type="check-circle" theme="filled" />,
  closable: false,
  maskClosable: true,
  centered: true,
  className: 'employee-success-form',
  onOk() {},
  onCancel() {},
};
export const successSendMessage = {
  ...optionsDefault,
  title: 'Сообщение успешно отправлено',
  content: `Спасибо! Ваше сообщение успешно отправлено.`,
};
